import { Element,Component, Prop, h, State } from '@stencil/core';
import { getServiceNumber } from '../../utils/ttarp';
import { setFeatureFlagsFromUrl, signaler } from '../../utils/signaler';
import phone from '../../assets/header/phone_icon.svg';
import logoLargeHorizontal from '../../assets/logo-large-horizontal.svg';
import { desktopBannerMessage, isBrowser, mobileBannerMessage } from '../../constants/constants';

@Component({
  tag: 'ci-header',
  styleUrl: 'ci-header.scss',
  assetsDirs: ['.../assets'],
  scoped: true,
})
export class CustominkHeader {
  @Element() $el: HTMLElement;
  @Prop() serviceNumber: string; // Allow an optional serviceNumber prop
  @Prop() mobileBannerMessage: string = mobileBannerMessage;
  @Prop() desktopBannerMessage: string = desktopBannerMessage;
  @Prop() signaler = signaler;
  @Prop({ mutable: true }) searchTestClass: string;
  @Prop() hideCart = false;
  @State() dynamicServiceNumber: string = '';
  @State() isFramer: boolean;
  @State() searchInHeaderTest: boolean;
  @State() visibleMenuBtn: boolean;
  @State() visibleMobileVisibility: boolean;
  @State() visibleOverlay: boolean;

  async componentWillLoad() {
    if (isBrowser) {
      setFeatureFlagsFromUrl(this.signaler);
      window.dispatchEvent(new Event('ciHeaderLoaded'));

      // If serviceNumber prop is not provided, fetch the dynamic service number
      if (!this.serviceNumber) {
        const fetchedServiceNumber = await getServiceNumber(); // Wait for the service number to resolve
        this.dynamicServiceNumber = fetchedServiceNumber;
      } else {
        this.dynamicServiceNumber = this.serviceNumber;
      }

      this.searchInHeaderTest = signaler.featureFlag('search_header_v7') === 'test';
      const url = window.location.href;
      this.isFramer = url.includes('iframer');
      this.searchTestClass = this.searchInHeaderTest && !this.isFramer ? 'ciHeader-main--withSearch' : '';
    }
  }


  render() {
    const onMenuBtnClick = () => {
      this.visibleMenuBtn = !this.visibleMenuBtn;
      const ciBodyTag = document.getElementsByTagName('body')[0] as HTMLElement;

      if (this.visibleMenuBtn) {
        this.visibleMobileVisibility = !this.visibleMobileVisibility;
        ciBodyTag.style.overflow = 'hidden';
      } else {
        setTimeout(() => {
          this.visibleMobileVisibility = !this.visibleMobileVisibility;
          ciBodyTag.style.overflow = 'visible';
        }, 200);
      }
    };

    return (
      <div class="ciHeader">
        <div class={{
          'ciHeader-overlay': true,
          'active': this.visibleOverlay,
          'openOverlay': this.visibleOverlay,
          'closeOverlay': !this.visibleOverlay,
        }} />
        <div class="ciHeader-banner">
          {isBrowser && (
            <div class="ciHeader-banner-wrapper">
              <div class="ciHeader-banner-title">
                <span class="ciHeader-banner-title--desktop">{this.desktopBannerMessage}</span>
                <span class="ciHeader-banner-title--mobile">{this.mobileBannerMessage}</span>
              </div>
              <div class="ciHeader-banner-actions">
                <ci-local-store></ci-local-store>
                <a class="ciHeader-banner-ttarpMobile ciHeader-phoneNumberLink" href={`tel:${this.dynamicServiceNumber}`}>
                  <img class="ciHeader-banner-ttarpMobile-icon" src={phone} alt="phone icon" />
                  <span class="ciHeader-banner-ttarpMobile-text">Help</span>
                </a>
              </div>
            </div>
          )}
        </div>
        <div class={`ciHeader-main ${this.searchTestClass ? this.searchTestClass : ''}`}>
          <div class="ciHeader-main-wrapper">
            <div class="ciHeader-subNav">
                 <div class={{
                "ciHeader-mobile-menu-btn": true,
                "active": this.visibleMenuBtn
              }} id="menuButton"
                onClick={() => {
                  onMenuBtnClick()
                }}>
                <span />
                <span />
                <span />
              </div>
              <ci-mobile-subnav
                serviceNumber={this.dynamicServiceNumber}
                visible={this.visibleMobileVisibility}
                visibleDrawer={this.visibleMenuBtn}
                onCloseDrawer={() => {
                onMenuBtnClick()
              }}></ci-mobile-subnav>
              <a href={`${process.env.CI_HOSTNAME}`} class="ciHeader-logo">
                <img alt="customink logo - inky" class="ciHeader-logo-image" src={logoLargeHorizontal} />
              </a>
            </div>
            {this.searchInHeaderTest && !this.isFramer && <ci-search id="searchOverlay"></ci-search>}
            <ci-navigation-rightside hideCart={this.hideCart}></ci-navigation-rightside>
            <div class="ciHeader-CustomerSupport">
              <customer-contact serviceNumber={this.dynamicServiceNumber}></customer-contact>
              <customer-chat></customer-chat>
            </div>
          </div>
        </div>
        <div class="ciHeader-navigation">
          <div class="ciHeader-main-wrapper">
            <div class="ciHeader-subNav">
              <ci-navigation
                onOpenOverlay={() => {
                  this.visibleOverlay = true
                }}
                onCloseOverlay={() => {
                  this.visibleOverlay = false
                }}
              ></ci-navigation>
            </div>
            <ci-navigation-rightside hideCart={this.hideCart}></ci-navigation-rightside>
          </div>
        </div>
      </div>
    );
  }
}
